var $f4c1f0d5d4d03d80$exports = {};
$f4c1f0d5d4d03d80$exports = {
  "deselectedItem": function deselectedItem(args) {
    return "Element ".concat(args.item, " ni izbran.");
  },
  "longPressToSelect": "Za izbirni na\u010Din pritisnite in dlje \u010Dasa dr\u017Eite.",
  "select": "Izberite",
  "selectedAll": "Vsi elementi so izbrani.",
  "selectedCount": function selectedCount(args, formatter) {
    return "".concat(formatter.plural(args.count, {
      "=0": "Noben element ni izbran",
      one: function one() {
        return "".concat(formatter.number(args.count), " element je izbran");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " elementov je izbranih");
      }
    }), ".");
  },
  "selectedItem": function selectedItem(args) {
    return "Element ".concat(args.item, " je izbran.");
  }
};
export { $f4c1f0d5d4d03d80$exports as default };